module.exports = __webpack_public_path__ + "img/text-video.64a9f4b3.svg";